import { AccountTemplate, Identifier, PropertyAddress } from '@types';
import QuickActions from '@components/QuickActions/QuickActions';

export interface AlertRibbonProps {
    alertdata: {
        notificationId: string;
        subject: string;
        content: string;
        link: string;
    };
}
export interface CardProps {
    borderColor?: string;
    colorWeight?: number;
    themeType?: string;
}
export interface MobielWidgetProps {
    component: string;
}
export interface WelcomeBarProps {
    name: string;
    loanOptions: Identifier[];
    getOption: (options: Identifier) => void;
    defaultOption?: Identifier;
    content?: string;
    updateLoanType?: (content: string) => void;
}

export interface ServicingLoanDetailProps {
    account: {
        accountNumber: string;
        escrowBalance: number;
        interestRate: number;
        loanBalance: number;
        maturityDate: string;
        originalLoanAmount: number;
        propertyAddress: PropertyAddress;
    };
    accountDetails?: () => void;
    component: string;
}
export interface MyProfileProps {
    component: string;
}

export interface NewLoanInProgressProps {
    statusTrackerUrl?: string;
    docUploadUrl?: string;
    loanOverviewUrl?: string;
    accessToken?: string;
    loanNumber?: string;
    loanStatus?: number;
    nlpWidgetList?: string[];
    handleErrorEvent?: (err: string) => void;
    docUploadClickHandler?: (accountNumber: string) => void;
    selfServUrl?: string;
    xApiKey?: string;
    getOption?: any;
}

export interface CashOutOfferProps {
    token?: string;
    cashOutUrl?: string;
    isCashOutOfferAvailable?: (status: boolean) => void;
    themeType?: string;
    navigationType?: (content: string) => void;
    loanNumber: string;
}

export interface DueDateProps {
    isPastDueAcc: boolean;
}

export interface TitleProps {
    isActive: boolean;
}

export interface QuickActionProps {
    handleDocument: (docType: string) => void;
}

export interface TaxDocumentProps {
    loanNumber: string;
    themeType: string;
    id: string;
}

export interface FeatureProductProps {
    selectedAccount: AccountTemplate;
}

export interface CmsCardProps {
    contentId: string;
    handleEnrollNow?: () => void;
    navigationType?: (content: string) => void;
}

export interface PaperlessEnrollmentProps {
    selectedAccount: AccountTemplate;
    themeType: string;
}

export interface CommonOfferProps {
    token?: string;
    cashOutUrl?: string;
    isCashOutOfferAvailable?: (status: boolean) => void;
    themeType?: string;
    navigationType?: (content: string) => void;
    offers?: any;
}

export enum AnimationType {
    DISCLOSURE = 'disclosure_animations',
    LOAN_SUMMARY = 'animations'
}
